import { render, staticRenderFns } from "./SidebarFilter.vue?vue&type=template&id=2aaa54e0&scoped=true&"
import script from "./SidebarFilter.vue?vue&type=script&lang=js&"
export * from "./SidebarFilter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFilter.vue?vue&type=style&index=0&id=2aaa54e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa54e0",
  null
  
)

export default component.exports